import { Fragment, useContext, useEffect, useState } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import {
  createQueryStringFromFilters,
  sendApiRequest,
} from "../../services/Base/base-service";

import UserContext from "../../store/user-context";
import Filters from "../../components/Header/Filters";
import { Alert, Section, Spinner } from "design-react-kit";
import Footer from "../../components/Footer";
import AuthModuleArchiveTable from "../../components/Tables/AuthModuleArchiveTable";

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 250];

const AuthModuleArchive = () => {
  const [flows, setFlows] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const getFilters = (newFilters) => {
    setCurrentPage(1);
    setFilters(newFilters);
  };

  useEffect(() => {
    if (filters !== null) {
      setTimeout(() => {
        getFlows(1, pageSize);
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const getFlows = (page = currentPage, size = pageSize) => {
    setIsLoading(true);
    setError(null);
    setTimeout(() => {
      sendApiRequest(
        "StagedFlows/GetAllStagedFlowsForArchive",
        "GET",
        true,
        { ...filters, skip: (page - 1) * size, take: size },
        signIn,
        signOut,
        navigate,
        createQueryStringFromFilters,
        userContext
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
            setIsLoading(false);
          } else {
            setError(null);
            setFlows(response.data.stagedFlowsForArchive);
            setTotalCount(response.data.totalCount);
            setIsLoading(false);
          }
        }
      });
    }, 500);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getFlows(page, pageSize);
  };

  const handlePageSizeChange = (size) => {
    setCurrentPage(1);
    setPageSize(size);
    getFlows(1, size);
  };

  return (
    <Fragment>
      <Filters page="authModuleArchive" getFilters={getFilters} />
      <Section>
        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="mx-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && (
          <p
            style={{
              height: "50px",
              position: "relative",
              marginBottom: "3rem",
            }}
          >
            <Spinner double active />
          </p>
        )}
        {error === null && !isLoading && (
          <AuthModuleArchiveTable
            items={flows}
            totalCount={totalCount}
            currentPage={currentPage}
            pageSize={pageSize}
            pageSizeOptions={PAGE_SIZE_OPTIONS}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            columns={[
              {
                name: "Data stato",
                type: "date",
                sortable: true,
                value: "modifiedOn",
              },
              {
                name: "Data acquisizione",
                type: "date",
                sortable: true,
                value: "predispositionDate",
              },
              {
                name: "Nome del flusso",
                type: "string",
                sortable: true,
                value: "name",
              },
              {
                name: "Tipologia",
                type: "string",
                sortable: false,
                value: "clientCodeName",
              },
              {
                name: "Formato",
                type: "string",
                sortable: false,
                value: "format",
              },
              {
                name: "Conteggio Notifiche",
                type: "integer",
                sortable: false,
                value: "notificationsCount",
              },
              {
                name: "Stato",
                type: "bool",
                sortable: false,
                value: "status",
              },
              {
                name: "",
                type: null,
                sortable: false,
                value: "",
              },
            ]}
            getFlows={getFlows}
            filters={filters}
          />
        )}
      </Section>
      <Footer />
    </Fragment>
  );
};

export default AuthModuleArchive;
